// PortfolioPage.js - Building Akron
import React, { useState} from 'react';
import './PortfolioPage.css';


const PortfolioPage = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const CORRECT_PASSWORD = process.env.REACT_APP_PORTFOLIO_PASSWORD;

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (password === CORRECT_PASSWORD) {
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('Incorrect password');
      setPassword('');
    }
  };


  // Password protection screen
  if (!isAuthenticated) {
    return (
      <div className="akron-password-screen">
        <div className="akron-password-container">
          <div className="akron-brand-header">
            <span className="akron-brand-name1">sterling rain</span>
            <span className="akron-brand-subtitle1">projects ltd.</span>
          </div>
          <form onSubmit={handlePasswordSubmit} className="akron-password-form">
            <h2>Protect Your Deck</h2>
            <p>(Best viewed on a desktop or in portrait orientation)</p>
            <div className="akron-input-group">
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                className="akron-password-input"
                autoFocus
              />
              <button type="submit" className="akron-password-submit">
                Enter
              </button>
            </div>
            {error && <p className="akron-error-message">{error}</p>}
          </form>
        </div>
      </div>
    );
  }

  return (
   <iframe src="https://docs.google.com/presentation/d/e/2PACX-1vQOHU81yYEwOceWGn3dOBg9vmPLCW-HYPOCSayqhvjmDljg9UAb-IBoYmOGIAmGLRAP4Inw9n2T_dEt/pubembed?start=false&loop=false&delayms=3000"
    style={{
      width: "100vw",
      height: "100vh",
      border: "none"
    }}
    title="Building Akron"
  allowFullScreen
>
    </iframe>
    );
};

export default PortfolioPage;
